import view from './view.html';

/* @ngInject */
export default function () {
	return {
		template:                   view,
		replace:                    true,
		scope:                      true,
		controller: /* @ngInject */ ($scope, STATUSES, $http, DataTablesService, moment, ReportsService, Reports) => {
			$scope.start = $scope.parameters.start;
			$scope.end   = $scope.parameters.end;

			const financialYear = ReportsService.financialYear();

			if (!$scope.start) {
				$scope.start = financialYear.start;
			}

			if (!$scope.end) {
				$scope.end = financialYear.end;
			}
			$scope.status = STATUSES.UNLOADED;

			$scope.dataTables = {};

			$scope.data  = [];
			$scope.error = null;

			$scope.leavingTypes = [
				'Family/Health/Study Concerns',
				'Found FT Work or Change of Jobs',
				'Low Hours/Service Problems',
				'Moved Interstate',
				'Not Advised',
				'Terminated by AAC',
				'Unhappy with AAC',
				'Other',
			];

			$scope.allLeavingTypes = [
				'All Leaving Types',
				'Leaving Type Not Set',
				...$scope.leavingTypes,
			];

			$scope.refresh = () => {
				$scope.status = STATUSES.LOADING;

				$scope.data  = [];
				$scope.error = null;

				return Reports.one($scope.reportId)
				              .one('execute')
				              .get({
					              start: $scope.start.format(),
					              end:   $scope.end.format(),
				              })
				              .then((data) => {
					              $scope.allLeavingTypes.forEach((leavingType) => {
						              $scope.dataTables[leavingType] = DataTablesService.configure({
							              id:                $scope.reportId,
							              title:             `${leavingType} - Exited Employees Summary Report`,
							              totalsColumns:     $scope.mapMonthHeaders(data.monthHeaders),
							              toggleableColumns: false,
							              frozenColumns:     true,
						              }, {
							              frozenLeftColumns: 1,
						              });
					              });

					              $scope.data  = data;
					              $scope.error = null;

					              $scope.status = STATUSES.LOADED;

					              return data;
				              })
				              .catch((error) => {
					              $scope.data  = [];
					              $scope.error = error;

					              $scope.status = STATUSES.ERRORED;
				              });
			};

			$scope.mapMonthHeaders = (monthHeaders, start) => {
				if (typeof start === 'undefined') {
					start = 1;
				}

				let output = {};

				monthHeaders.forEach((month, index) => {
					output[month] = index + start;
				});

				return output;
			};

			$scope.refresh();
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/report/reports/B840FE7A-D464-43BF-9AEB-8028607CF4D2/index.js